import { Component } from '@angular/core';

@Component({
  selector: 'cdm-manizales-map-filter-legend-matrix-od',
  templateUrl: './map-filter-legend-matrix-od.component.html',
  styleUrls: ['./map-filter-legend-matrix-od.component.scss'],
})
export class MapFilterLegendMatrixODComponent {}
